import type { FunctionComponent } from 'preact';
import { Button } from '../Button/Button.js';
import { useCloudpack } from '../CloudpackProvider/CloudpackProvider.js';
import { PathError } from './PathError.js';
import type { UnsupportedErrorEvent } from './useErrorEvents.js';
import { Dialog } from '../Dialog/Dialog.js';
import { elementIds } from '../../constants.js';
import { Refresh20 } from '../icons/Refresh20.js';

export interface ErrorDialogProps {
  unsupported: UnsupportedErrorEvent[];
}

export const ErrorDialog: FunctionComponent<ErrorDialogProps> = ({ unsupported }) => {
  const cloudpack = useCloudpack();

  const reload = () => void cloudpack.restartAllTasks.mutate();
  const editConfig = () => void cloudpack.openConfigEditor.mutate();

  return (
    <Dialog
      title="Cloudpack: Unrecognized imports found in project"
      id={elementIds.errorDialogRoot}
      style="error"
      commands={
        <>
          <Button variant="primary" onClick={reload}>
            <Refresh20 /> Retry bundling
          </Button>
          <Button onClick={editConfig}>Edit Cloudpack config</Button>
        </>
      }
    >
      {unsupported.map((data, index) => (
        <PathError {...data} index={index} key={index} />
      ))}
    </Dialog>
  );
};

export default ErrorDialog;
